import { render, staticRenderFns } from "./deliveryorder.vue?vue&type=template&id=5cbc1f8a&scoped=true&"
import script from "./deliveryorder.vue?vue&type=script&lang=js&"
export * from "./deliveryorder.vue?vue&type=script&lang=js&"
import style0 from "./deliveryorder.vue?vue&type=style&index=0&id=5cbc1f8a&scoped=true&lang=css&"
import style1 from "./deliveryorder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbc1f8a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VChip,VCombobox,VContainer,VDataTable,VFlex,VLayout,VTextField})
